<div class="wrapper" style="height: 100%;" #wrapper>
    <app-modal-header [text]="'terms_and_conditions' | localise" (close)="bsModalRef.hide()"></app-modal-header>

    <ng-container *ngIf="!loading">
        <div class="modal-body" [innerHTML]="termsAndConditions.text"></div>
    </ng-container>
    <ng-container *ngIf="loading">
        <app-loading></app-loading>
    </ng-container>
</div>
